import { DateUtils } from "shared/dateUtils";

const isAValidNumber = (number) => {
  if (typeof number === "number") {
    number = number.toString().replace(/\./g, ",");
  }
  const valid = /^\d+(,\d+)?$/.test(number);
  return valid;
};

export const validate = (values, t) => {
  const errors = {};
  if (values.formulaId !== null && !isAValidNumber(values.amountTroughBags)) {
    errors.amountTroughBags = t("errors:supplementation.not-valid-amount-trough-bags");
  }
  if (values.formulaId !== null && values.amountTroughBags === null) {
    errors.amountTroughBags = t("errors:supplementation.required-amount-trough-bags");
  }
  if (
    values.formulaId !== null &&
    values.amountTroughBags !== null &&
    Number(values.amountTroughBags) === 0
  ) {
    errors.amountTroughBags = t("errors:supplementation.more-than-zero-amount-trough-bags");
  }

  if (values.collectionDate) {
    const date = DateUtils.utc(values.collectionDate);
    const now = DateUtils.now();
    if (now < date) {
      errors.collectionDate =
        t("common:validation.not-select-future-date");
    } else if (now.subtract(60, "days") > date.endOf("day")) {
      errors.collectionDate = t("common:validation.sixty-days-before-today-to-edit-date");
    }
  }
  return errors;
};
